import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-[#4A3B36] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Coluna 1 - Links Rápidos */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#D4B4A8]">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="#sobre" className="text-white/90 hover:text-[#D4B4A8] transition-colors duration-300">
                  Sobre
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-white/90 hover:text-[#D4B4A8] transition-colors duration-300">
                  Serviços
                </a>
              </li>
              <li>
                <a href="#contato" className="text-white/90 hover:text-[#D4B4A8] transition-colors duration-300">
                  Contato
                </a>
              </li>
              <li>
                <Link to="/politica-de-privacidade" className="text-white/90 hover:text-[#D4B4A8] transition-colors duration-300">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          {/* Coluna 2 - Contato */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#D4B4A8]">Contato</h3>
            <div className="space-y-4">
              <motion.a
                href="https://api.whatsapp.com/send/?phone=5562982615656"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-white/90 hover:text-[#D4B4A8] transition-colors duration-300"
                whileHover={{ x: 5 }}
              >
                <FaWhatsapp className="text-xl" />
                <span>Whatsapp</span>
              </motion.a>
              <motion.a
                href="https://www.instagram.com/psi.ke"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-white/90 hover:text-[#D4B4A8] transition-colors duration-300"
                whileHover={{ x: 5 }}
              >
                <FaInstagram className="text-xl" />
                <span>@psi.ke</span>
              </motion.a>
            </div>
          </div>

          {/* Coluna 3 - Horário de Atendimento */}
         <div>
          <h3 className="text-xl font-semibold mb-4 text-[#D4B4A8]">Horário de Atendimento</h3>
          <p className="text-white/90 text-sm leading-relaxed">
          Segunda e Quinta<br />
          Atendimentos Presenciais: 8h às 20h<br />
          <br />
          Terça, Quarta e Sexta<br />
          Atendimentos Online: 8h às 20h<br />
          <br />
          Mediante agendamento
         </p>
         </div>

        </div>

        {/* Developer Logo */}
        <div className="mt-8 flex justify-end items-center">
          <span className="text-white/90 mr-2">Desenvolvido por:</span>
          <a 
            href="https://omnis.digital" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#D4B4A8] hover:text-white transition-colors duration-300"
          >
            OmnisDigital
          </a>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-[#D4B4A8]/20 text-center text-sm text-white/80">
          <p>&copy; {new Date().getFullYear()} Késia Almeida - Psicóloga. Todos os direitos reservados.</p>
          <p className="mt-2 text-[#D4B4A8]">CRP: 09/16980</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
